import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const TopSmartScoreStocksCanada = () => {
  const [stocks, setStocks] = useState(() => {
    const savedStocks = sessionStorage.getItem("top-smart-stocks-ca");
    return savedStocks ? JSON.parse(savedStocks) : [];
  });
  const [filteredStocks, setFilteredStocks] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (stocks.length > 0) {
      setFilteredStocks(stocks);
      setLoading(false);
      return;
    }
    const fetchStocks = async () => {
      try {
        const timeStamp = Date.now();
        const response = await axios.get(
          `https://tr-cdn.tipranks.com/research/prod/screener/top-smart-score-stocks/canada/payload.json?ver=${timeStamp}`
        );
        const sortedStocks = response.data.TopSmartScore.data.stocks.list.filter(x => x.analystRatings?.consensus?.priceTarget?.value).sort((a, b) => {
          // const aPercent = ((a.analystRatings?.consensus?.priceTarget.value - a.price) / a.price) * 100;
          // const bPercent = ((b.analystRatings?.consensus?.priceTarget.value - b.price) / b.price) * 100;
          // if (bPercent !== aPercent) {
          //   return bPercent - aPercent;
          // }
          return b.marketCap - a.marketCap;
        });
        setStocks(sortedStocks);
        setFilteredStocks(sortedStocks);
        sessionStorage.setItem("top-smart-stocks-ca", JSON.stringify(sortedStocks));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(`Failed to fetch stock data. ${err}`);
        setLoading(false);
      }
    };
    fetchStocks();
  }, []);

  if (loading) return <div className="text-center mt-3 text-light">Loading...</div>;
  if (error) return <div className="text-center mt-3 text-danger">{error}</div>;

  return (
    <div className="table-container text-light">
      <h6 className="mb-4">Top Smart Score Stocks 🇨🇦</h6>
      <div class="d-flex justify-content-center mb-4">
        <div class="col-md-3">
          <input
            type="text"
            class="form-control"
            id="search_text"
            placeholder="Search"
            onChange={(e) => {
              const searchText = e.target.value;
              setFilteredStocks(
                stocks.filter(
                  (i) => i.ticker.toLowerCase().includes(searchText) || i.name.toLowerCase().includes(searchText)
                )
              );
              setSearchText(searchText);
            }}
          ></input>
        </div>
      </div>
      <div
        style={{
          maxHeight: "85vh",
          overflowY: "auto",
          overflowX: "scroll",
        }}
      >
        <table className="table table-striped table-bordered table-dark w-100">
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "#212529",
              zIndex: 1,
            }}
          >
            <tr>
              <th scope="col">Ticker</th>
              <th scope="col">Name</th>
              <th scope="col">Sector</th>
              <th scope="col">Current Price</th>
              <th scope="col">Target Price</th>
              {/* <th scope="col">Low Target</th>
              <th scope="col">High Target</th> */}
              <th scope="col">Score</th>
              <th scope="col">Market Cap</th>
              <th scope="col">Buy</th>
              <th scope="col">Hold</th>
              <th scope="col">Sell</th>
            </tr>
          </thead>
          <tbody>
            {filteredStocks.map((stock, index) => {
              const currentPrice = stock.price;
              const analystRating = stock.analystRatings ?? {};
              const priceTarget = analystRating.consensus?.priceTarget.value ?? currentPrice;
              // const percentDiff = ((priceTarget - currentPrice) / currentPrice) * 100;
              // const isUp = priceTarget > currentPrice;

              // const lowPTarget = analystRating.consensus?.lowPriceTarget;
              // const highPTarget = analystRating.consensus?.highPriceTarget;

              return (
                <tr
                  key={index}
                  onClick={() => navigate(`/stocks/${stock.ticker}`, { state: { stock } })}
                  style={{ cursor: "pointer" }}
                >
                  <td>{stock.ticker}</td>
                  <td>{stock.name}</td>
                  <td>{stock.sector}</td>
                  <td>${stock.price?.toFixed(2)}</td>
                  <td>
                    ${priceTarget?.toFixed(2)}{" "}
                    <span style={{ color: priceTarget > currentPrice ? "#28a745" : "#dc3545" }}>
                      {priceTarget > currentPrice ? "↑" : "↓"}{" "}
                      {Math.abs(((priceTarget - currentPrice) / currentPrice) * 100).toFixed(2)}%
                    </span>
                  </td>
                  {/* <td>
                    ${lowPTarget?.toFixed(2)}{" "}
                    <span style={{ color: lowPTarget > currentPrice ? "#28a745" : "#dc3545" }}>
                      {lowPTarget > currentPrice ? "↑" : "↓"}{" "}
                      {Math.abs(((currentPrice - lowPTarget) / currentPrice) * 100).toFixed(2)}%
                    </span>
                  </td>
                  <td>
                    ${highPTarget?.toFixed(2)}{" "}
                    <span style={{ color: highPTarget > currentPrice ? "#28a745" : "#dc3545" }}>
                      {highPTarget > currentPrice ? "↑" : "↓"}{" "}
                      {Math.abs(((highPTarget - currentPrice) / currentPrice) * 100).toFixed(2)}%
                    </span>
                  </td> */}
                  <td>{stock.smartScore.value}</td>
                  <td>${(stock.marketCap / 1000000000).toFixed(2)}B</td>
                  <td>{analystRating.consensus?.buy}</td>
                  <td>{analystRating.consensus?.hold}</td>
                  <td>{analystRating.consensus?.sell}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopSmartScoreStocksCanada;
